<template>
  <router-view></router-view>
</template>

<script>
  
  import axios from 'axios';
  export default {

    data () {
      return {

        isAuthOnLoad: false
      }
    },

    created() {
      this.checkAuth();
    },

    methods: {

      trackEvent( eventCategory, eventAction, eventLabel ) {

        if ( typeof(EWAnalytics) == 'undefined' ) {
          return;
        }

        EWAnalytics('send', 'event', eventCategory, eventAction, eventLabel );
      },

      sendToLogin( targetUrl ) {

        this.setLoginFromQPCookie();
        window.location.href = `${window.location.origin}/login/ew?next=${targetUrl}`;
      },

      logoutIfInvalidToken( err ) {

        if( err && err.code === 4002  ) {

          window.location.href = "/logout?next="+ window.location.pathname;
        }
      },

      setLoginFromQPCookie() {

        document.cookie = "login-via-qp=yes; path=/";
      },

      deleteLoginFromQPCookie() {

        document.cookie = "login-via-qp=;expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
      },

      getLoginFromQPCookie() {

        var i,x,y, cookies = document.cookie.split(";");
        for ( i=0; i < cookies.length; i++ ){

            x = cookies[i].substr(0,cookies[i].indexOf("="));
            y = cookies[i].substr(cookies[i].indexOf("=")+1);
            x = x.replace(/^\s+|\s+$/g,""); //trim
            if ( x == 'login-via-qp' ) {

                return decodeURI(y);
            }
        }
        return '';
      },

      checkAuth() {
        
        this.isAuthOnLoad = false;
        axios.get(`/ajax/check-auth`).then((response)=> {

          if( response.data.status && response.data.isAuthenticated ) {
            
            this.isAuthOnLoad = true;
          }
        }).catch(() =>{}).finally(()=> {

          let isComingFromLogin = ( this.getLoginFromQPCookie() == "yes"  ) || false;

          if( isComingFromLogin ) {

            this.deleteLoginFromQPCookie();
          }

          if ( typeof(EWAnalytics) == 'undefined' ) {
            return;
          }

          EWAnalytics('set', 'dimension1',  ( this.isAuthOnLoad ? 'registered': 'guest' )  );

          if( isComingFromLogin && this.isAuthOnLoad ) {

            EWAnalytics('set', 'dimension2',  'login-via-question-practice'  );
          }
        });
      },
    }
  };
</script>
<style>
  
  body{
    margin:0;
    padding:0;
    width:100%;
    min-height:100%;
    background:#fff;
    color:#000;
    font-family:Hind,sans-serif;
    font-style:normal;
    font-weight:400;
    position:relative;
    overflow-x:hidden
  }
  a.active,a:focus,a:hover,a:visited{
      color:#999;
      text-decoration:none
  }
  h1,h2,h3,h4{
      margin:0
  }
  ul{
      list-style-type:none;
      padding-left:0;
      margin-bottom:0
  }
  h1{
      font-size:30px
  }
  h2{
      font-size:24px
  }
  h3{
      font-size:20px
  }
  h4{
      font-size:18px
  }

  .slider-section{
      float:left;
      width:100%
  }
  .slider-box .carousel{
      top:-11px
  }
  .carousel-dot li{
      position:relative;
      -ms-flex:0 1 auto;
      -webkit-box-flex:0;
      flex:0 1 auto;
      width:15px;
      height:15px;
      margin-right:3px;
      margin-left:3px;
      text-indent:-999px;
      background-color:hsla(0,0%,100%,.5);
      border-radius:15px
  }
  .carousel-caption{
      bottom:25%
  }
  .owl-theme .owl-controls{
      margin-top:10px
  }
  .owl-theme .owl-controls .owl-page span{
      background:#5e5f5f;
      opacity:1;
      -webkit-transition:all .4s ease 0s;
      transition:all .4s ease 0s
  }
  .owl-theme .owl-controls.clickable .owl-page:hover span,.owl-theme .owl-controls .owl-page.active span{
      background:#333
  }
  .owl-theme .owl-controls .owl-page.active span{
      width:22px;
      height:12px
  }
  .qp-card-view {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    background: white;
    padding: 0 !important;
  }
  .qp-card-header {
    height: 100px;
    width: 100%;
    padding: 15px;
    border-bottom: 1px solid #e9ecef;
    background: #fff;
  }
  .qp-card-body {
    height: calc(100% - 100px);
    overflow-y: auto;
    padding: 15px 15px 0 15px;
  }

  .qp-card-footer {
    height: 48px;
    display: none;
    width: 100%;
    background: rgb(43, 43, 43)
  }

  .qp-card-footer a {
    background: #e1b606;
    display: inline-block;
    padding: 12px 13px;
    border: 1px solid #2b2b2b;
    font-size: 15px;
    text-transform: uppercase;
    font-weight: 600;
    color: #333;
  }

  .question-choices-card img {
    display: block;
    max-width: 100%;
    height: auto!important;
    cursor: pointer;
  }

  .qp-card-footer a.disabled-btn {
    background: #3e3e3e;
    color: #fff;
    pointer-events: none;
    cursor: default;
  }
  .set-practice-overlay {
    margin: auto;
    background-color: rgba(0, 0, 0, .2);
    display: flex;
    position: absolute;
    z-index: 999;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .set-practice-overlay>img {
    margin: auto;
    max-width: 100%;
    max-height: 100%;
  }
  @media only screen and (max-width: 767px) {
    .qp-card-title h6 {
      font-size: 14px !important;
    }
  }
  .qp-card-title {
    float: left;
  }
  .quit-question-practice-set-btn {
    background: #ca0404;
    color: #fff;
    border: none;
    cursor: pointer;
    font-size: 14px;
    padding: 4px 15px;
  }
  .set-filter-form-row >.col-4{
    padding-bottom: 8px;
  }
  .set-status-new, .set-status-progress, .set-status-done  {

    text-decoration: none;
    padding: 8px 16px;
    color: black !important;
    float: right;
  }
  .set-status-new{
    background-color: #0dad13;
  }
  .set-status-progress {
    background-color: #03a0dc;
  }
  .set-status-done {
    background-color: #e08122;
  }
  .set-question-submit-attempt {
    background: #28a745;
    display: none;
    color: #fff;
    border: none;
    cursor: pointer;
    font-size: 14px;
    padding: 4px 15px;
  }

  .set-question-submit-attempt.disabled-btn {
    background: #3e3e3e;
    color: #fff;
    pointer-events: none;
    cursor: default;
  }

  .social-widget-qs li a i {
    font-size: 29px;
    margin-right: 3px;
    opacity: .68;
    color: #000;
  }
</style>
